

















































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';
import numberFormat from '@/libs/numberFormat';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    TagInput,
  },
  methods: {
    numberFormat,
  },
})
export default class ReportDetail extends Vue {
  loading = false;
  transactionStatus = {
    '00': 'Success',
    '01': 'Failed',
  }

  numberFormat!: typeof numberFormat;

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    return dayjs(time).format('MMMM D, YYYY HH:mm:ss');
  }
}
